import { Color } from 'lib/Chip';

export type ExportJobStatus = 'PROCESSING' | 'COMPLETE' | 'FAILED';

export const ExportJobStatusName: { [key in ExportJobStatus]: string } = {
  PROCESSING: 'In Progress',
  COMPLETE: 'Completed',
  FAILED: 'Failed',
};

export const ExportJobStatusColor = {
  PROCESSING: Color.ORANGE,
  COMPLETE: Color.LIME,
  FAILED: Color.RED,
};

export interface ExportJob {
  jobId: string;
  status: ExportJobStatus;
  fileName: string;
  fileSize: number;
  selectedMarkets: string;
  createdDate: Date;
  completedDate: Date;
  downloadUrl: string;
}
